export const MEETING_RESULTS_LOGIC_ROLE = Object.freeze({
  SCHEDULED: 'ACTIVITY__MEETING_RESULT__SCHEDULED',
  NO_SHOW: 'ACTIVITY__MEETING_RESULT__NO_SHOW',
  UNQUALIFIED: 'ACTIVITY__MEETING_RESULT__UNQUALIFIED',
  UNQUALIFIED_LEAD: 'ACTIVITY__MEETING_RESULT__UNQUALIFIED_LEAD',
  QUALIFIED: 'ACTIVITY__MEETING_RESULT__QUALIFIED',
});
